import { createContext, useState } from 'react';
import { IMenuItem } from '../interfaces/items';

interface IStateQuestions {
    selectedMenu: IMenuItem;
    progressQuestions: number;
    canApply: boolean;
    showModalApply: boolean;
    showModalUser: boolean;
    userId: number;
    changeSelectedMenu: Function;
    changeProgressQuestions: Function;
    changeCanApply: Function;
    changeShowModalApply: Function;
    changeShowModalUser: Function;
    changeUserId: Function;
}

interface IQuestionsContext {
    children: any;
}

const initQuestions: IMenuItem = {
    label: '',
    value: '',
};

const initialState: IStateQuestions = {
    selectedMenu: initQuestions,
    progressQuestions: 0,
    canApply: false,
    showModalApply: false,
    showModalUser: false,
    userId: 0,
    changeProgressQuestions: () => {},
    changeSelectedMenu: () => {},
    changeCanApply: () => {},
    changeShowModalApply: () => {},
    changeShowModalUser: () => {},
    changeUserId: () => {},
};

const QuestionsContext = createContext(initialState);

const QuestionsContextProvider = ({ children }: IQuestionsContext) => {
    let [selectedMenu, setSelectedMenu] = useState<IMenuItem>(initQuestions);
    let [progressQuestions, setProgressQuestions] = useState<number>(0);
    let [canApply, setCanApply] = useState<boolean>(false);
    let [showModalApply, setShowModalApply] = useState<boolean>(false);
    let [showModalUser, setShowModalUser] = useState<boolean>(false);
    let [userId, setUserId] = useState<number>(0);

    const changeSelectedMenu = (m: IMenuItem) => {
        setSelectedMenu(m);
    };

    const changeProgressQuestions = (p: number) => {
        setProgressQuestions(p);
    };

    const changeCanApply = (a: boolean) => {
        setCanApply(a);
    };

    const changeShowModalApply = (m: boolean) => {
        setShowModalApply(m);
    };

    const changeShowModalUser = (m: boolean) => {
        setShowModalUser(m);
    };

    const changeUserId = (iD: number) => {
        setUserId(iD);
    };

    return (
        <QuestionsContext.Provider
            value={{
                selectedMenu,
                progressQuestions,
                canApply,
                showModalApply,
                showModalUser,
                userId,
                changeProgressQuestions,
                changeSelectedMenu,
                changeCanApply,
                changeShowModalApply,
                changeShowModalUser,
                changeUserId,
            }}
        >
            {children}
        </QuestionsContext.Provider>
    );
};

export { QuestionsContext, QuestionsContextProvider };
